import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=25dedb29&scoped=true"
import script from "./confirmModal.vue?vue&type=script&lang=js"
export * from "./confirmModal.vue?vue&type=script&lang=js"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=25dedb29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dedb29",
  null
  
)

export default component.exports